module.exports = __webpack_public_path__ + "img/1.a690e542.jpg";